import React, { useState } from 'react'
import { PencilSquareIcon, TrashIcon, QrCodeIcon, PrinterIcon, ArrowDownTrayIcon, MapIcon } from '@heroicons/react/24/outline'
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
// import TableComponent from 'components/common/TableComponent'
import 'styles/BlockTable.css'
import BlockQRModal from 'components/modals/BlockQRModal'
import BlockMapModal from 'components/modals/BlockMapModal'
import { makeRequest } from 'services/request.service'
import { showAlert } from 'services/alerts.service'

import { formatNumbers } from 'utils'

const BlockTable = ({
  filteredBlocks,
  blockGroups,
  onEdit,
  onDelete,
  onUpdateBlockConfig,
  toggleIsTunnelRowModalOpen,
  tunnelRefreshRef
}) => {
  const [isQRModalOpen, setIsQRModalOpen] = useState(false)
  const [selectedBlock, setSelectedBlock] = useState(null)
  const [selectedMapBlock, setSelectedMapBlock] = useState(null)
  const [printingBlockId, setPrintingBlockId] = useState(null)
  const [downloadingBlockId, setDownloadingBlockId] = useState(null)

  const handleOpenMapModal = (block) => {
    setSelectedMapBlock(block)
  }

  const handleCloseMapModal = () => {
    setSelectedMapBlock(null)
  }

  const getBlockGroupName = (bgId) => {
    const group = blockGroups.find((bg) => bg.blockGroupId === bgId)
    return group?.groupName || ''
  }

  const getUnitsPerArea = (totalUnits, area) => {
    return Number(parseFloat(totalUnits) / parseFloat(area)).toFixed(2)
  }

  const handleOpenQRModal = (block) => {
    setSelectedBlock(block)
    setIsQRModalOpen(true)
  }

  const handleCloseQRModal = () => {
    setSelectedBlock(null)
    setIsQRModalOpen(false)
  }

  const getSubBlock = (rowId) => {
    if (typeof rowId !== 'string') return '-'
    if (rowId.includes('SUB_A')) return 'Sub A'
    if (rowId.includes('SUB_B')) return 'Sub B'
    return '-'
  }

  const handleDownloadInfo = async (block) => {
    setDownloadingBlockId(block.farmingBlockId)
    try {
      const response = await makeRequest({
        method: 'GET',
        url: `/management/farming-blocks/${block.farmingBlockId}/rows`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('secret')}`
        }
      })

      const rows = Array.isArray(response.data) ? response.data : []

      const tableRows = rows.map(row => [
        block.name,
        getSubBlock(row.rowId),
        row.location || '-',
        row.barcode || '-',
        row.rowId || '-'
      ])

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' })

      doc.setFontSize(14)
      doc.setTextColor(5, 81, 13)
      doc.text(`Block Info: ${block.name}`, 14, 14)

      autoTable(doc, {
        startY: 20,
        head: [['Block Name', 'Sub-block', 'Row Column (Legacy)', 'Barcode (Legacy)', 'Barcode']],
        body: tableRows,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [5, 81, 13] }
      })

      doc.save(`${block.name}_info.pdf`)
    } catch (error) {
      console.error('Error downloading block info:', error)
      showAlert({ text: 'Failed to download block info', icon: 'error' })
    } finally {
      setDownloadingBlockId(null)
    }
  }

  const handlePrintClick = async (block) => {
    // Prevent multiple clicks by setting loading state
    setPrintingBlockId(block.farmingBlockId)
    try {
      const response = await makeRequest({
        method: 'GET',
        url: `/management/farming-blocks/${block.farmingBlockId}/labels`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('secret')}`
        },
        responseType: 'blob' // Important for binary data (PDF)
      })

      // Create a blob URL and download the PDF
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${block.name}_labels.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error downloading block labels:', error)
      showAlert({
        text: 'Failed to download block labels',
        icon: 'error'
      })
    } finally {
      // Reset loading state
      setPrintingBlockId(null)
    }
  }

  // const blocksDataTable = {
  //   columns: [
  //     { key: 'farmingBlockId', label: '#' },
  //     {
  //       key: 'name',
  //       label: 'Name',
  //       cell: (block, _, toggleExpand) => (
  //         <button onClick={() => toggleExpand(block.farmingBlockId)} className='clickable'>
  //           {block.name}
  //         </button>
  //       )
  //     },
  //     {
  //       key: 'totalPlants',
  //       label: 'Total Plants',
  //       cell: block => formatNumbers(block.totalPlants)
  //     },
  //     {
  //       key: 'area',
  //       label: 'Area M²',
  //       cell: block => formatNumbers(block.area)
  //     },
  //     {
  //       key: 'unitsPerArea',
  //       label: 'Units/Area',
  //       cell: block => formatNumbers(getUnitsPerArea(block.totalPlants, block.area))
  //     },
  //     { key: 'cropName', label: 'Default Crop' },
  //     { key: 'varietyName', label: 'Default Variety' },
  //     {
  //       key: 'groupName',
  //       label: 'Group Name',
  //       cell: block => getBlockGroupName(block.blockGroupId)
  //     },
  //     {
  //       key: 'actions',
  //       label: 'Actions',
  //       cell: block => (
  //         <div className='flex gap-2'>
  //           <button onClick={() => onEdit({ ...block })}>
  //             <PencilSquareIcon className='w-5 h-5 text-blue-500' />
  //           </button>
  //           <button onClick={() => onDelete(block.farmingBlockId)}>
  //             <TrashIcon className='w-5 h-5 text-red-500' />
  //           </button>
  //         </div>
  //       )
  //     }
  //   ],
  //   rows: filteredBlocks
  // }

  return (
    <div>
      {/* {filteredBlocks.length !== 0 &&
        <TableComponent
          tableData={blocksDataTable}
          renderExpandedRow={(row) => (
            <BlockMapComponent
              toggleIsTunnelRowModalOpen={toggleIsTunnelRowModalOpen}
              {...row}
              farmingBlockId={row.farmingBlockId}
              isHydroponicBlock={row.isHydroponicBlock}
            />
          )}
          getRowId={(row) => row.farmingBlockId}
        />} */}

      <div className='overflow-x-auto max-w-5l'>
        <div className='table-container table-wrapper'>
          <table className='table w-full border-rounded-lg border border-gray-200 text-left'>
            <thead>
              <tr className='cursor-pointer text-greenPrimary hover:bg-gray-100 transition-colors duration-200'>
                <th>#</th>
                <th>Name</th>
                <th>Total Plants</th>
                <th>Area M²</th>
                <th>Units/Area</th>
                <th>Crop</th>
                <th>Variety</th>
                <th>Group Name</th>
                <th>Manage</th>
              </tr>
            </thead>
            <tbody>
              {filteredBlocks.map((block, index) => (
                <React.Fragment key={block.farmingBlockId}>
                  <tr>
                    <td>{block.farmingBlockId}</td>
                    <td className='clickable' onClick={() => handleOpenMapModal(block)}>{block.name}</td>
                    <td>{formatNumbers(block.totalPlants)}</td>
                    <td>{formatNumbers(block.area)}</td>
                    <td>{formatNumbers(getUnitsPerArea(block.totalPlants, block.area))}</td>
                    <td>{block.cropName}</td>
                    <td>{block.varietyName}</td>
                    <td>{getBlockGroupName(block.blockGroupId)}</td>
                    <td>
                      <div className='flex gap-2'>
                        <button onClick={() => handleOpenQRModal(block)} title='QR Code'>
                          <QrCodeIcon className='w-5 h-5 text-green-500' />
                        </button>
                        <button onClick={() => handleOpenMapModal(block)} title='View Block Map' aria-label={`View block map for ${block.name}`}>
                          <MapIcon className='w-5 h-5 text-emerald-600' />
                        </button>
                        <button
                          onClick={() => handleDownloadInfo(block)}
                          title={downloadingBlockId === block.farmingBlockId ? 'Generating...' : 'Download Block Info'}
                          disabled={downloadingBlockId === block.farmingBlockId}
                          className={`${downloadingBlockId === block.farmingBlockId ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                          {downloadingBlockId === block.farmingBlockId
                            ? (
                              <div className='w-5 h-5 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin' />
                              )
                            : (
                              <ArrowDownTrayIcon className='w-5 h-5 text-purple-500' />
                              )}
                        </button>
                        <button
                          onClick={() => handlePrintClick(block)}
                          title={printingBlockId === block.farmingBlockId ? 'Generating PDF...' : 'Print Labels'}
                          disabled={printingBlockId === block.farmingBlockId}
                          className={`${printingBlockId === block.farmingBlockId ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                          {printingBlockId === block.farmingBlockId
                            ? (
                              <div className='w-5 h-5 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin' />
                              )
                            : (
                              <PrinterIcon className='w-5 h-5 text-gray-600' />
                              )}
                        </button>
                        <button onClick={() => onEdit({ ...block })} title='Edit'>
                          <PencilSquareIcon className='w-5 h-5 text-blue-500' />
                        </button>
                        <button onClick={() => onDelete(block.farmingBlockId)} title='Delete'>
                          <TrashIcon className='w-5 h-5 text-red-500' />
                        </button>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {isQRModalOpen && selectedBlock && (
        <BlockQRModal
          isOpen={isQRModalOpen}
          onClose={handleCloseQRModal}
          blockId={selectedBlock.farmingBlockId}
          blockName={selectedBlock.name}
        />
      )}
      <BlockMapModal
        isOpen={Boolean(selectedMapBlock)}
        onClose={handleCloseMapModal}
        block={selectedMapBlock}
        onUpdateBlockConfig={onUpdateBlockConfig}
        toggleIsTunnelRowModalOpen={toggleIsTunnelRowModalOpen}
        tunnelRefreshRef={tunnelRefreshRef}
      />
    </div>
  )
}

export default BlockTable
